import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ChatNavbar from '../Body/Navbar/ChatNavbar'
import MessagesContainer from '../Body/MessagesContainer'

const ChatBody = ({
  selectedChat,
  isLoading,
  currentBuildingId,
  currentUserData,
  managementUsers,
  highManagementUsers,
  assignedConversationData,
  cancelLoading,
  currentBuildingTimezone,
  closedConversationsData,
  textingOptOutInfo,
  isAiWriterAvailable,
  conversationAttributeFilter,
  setConversationAttributeFilter,
  counts,
  filterOptions,
}) => {
  const { t } = useTranslation(['chat'])
  return (
    <div className="chat__messages-window-container">
      <div className="chat__filters-container">
        {filterOptions.map((option) => (
          <button
            key={option.value}
            className={`chat__filter-item ${
              conversationAttributeFilter === option.value ? 'active' : ''
            }`}
            onClick={() => setConversationAttributeFilter(option.value)}
          >
            {option.label} <span className="chat__filter-badge">{counts[option.value] || 0}</span>
          </button>
        ))}
      </div>
      {selectedChat ? (
        <div className="messages-window">
          <ChatNavbar
            selectedChat={selectedChat}
            currentBuildingId={currentBuildingId}
            managementUsers={managementUsers}
            assignedConversationData={assignedConversationData}
          />
          <MessagesContainer
            currentUserData={currentUserData}
            selectedChat={selectedChat}
            isLoading={isLoading}
            cancelLoading={cancelLoading}
            managementUsers={[...managementUsers, ...highManagementUsers]}
            currentBuildingId={currentBuildingId}
            currentBuildingTimezone={currentBuildingTimezone}
            closedConversationsData={closedConversationsData}
            textingOptOutInfo={textingOptOutInfo}
            isAiWriterAvailable={isAiWriterAvailable}
          />
        </div>
      ) : (
        <div className="no-chat-selected">{t('chat:chatBody.selectRoomPrompt')}</div>
      )}
    </div>
  )
}

ChatBody.propTypes = {
  selectedChat: PropTypes.object,
  isLoading: PropTypes.bool,
  currentBuildingId: PropTypes.number,
  currentUserData: PropTypes.object,
  managementUsers: PropTypes.array,
  highManagementUsers: PropTypes.array,
  assignedConversationData: PropTypes.arrayOf(PropTypes.object),
  currentBuildingTimezone: PropTypes.string,
  closedConversationsData: PropTypes.array,
  cancelLoading: PropTypes.func,
  textingOptOutInfo: PropTypes.bool,
  isAiWriterAvailable: PropTypes.bool,
  conversationAttributeFilter: PropTypes.string,
  setConversationAttributeFilter: PropTypes.func,
  counts: PropTypes.object,
  filterOptions: PropTypes.array,
}

export default ChatBody
